import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Folder} from '../folder';
import {FolderService} from '../folder.service';

@Component({
    selector: 'app-folder-list',
    templateUrl: './folder-list.component.html',
    styleUrls: ['./folder-list.component.css']
})
export class FolderListComponent implements OnInit, OnChanges {
    folders: Folder[] = [];
    @Input() hasFolderId?: boolean;
    @Input() folderId?: number;
    @Output() emitter: EventEmitter<object> = new EventEmitter();

    constructor(private folderService: FolderService) {
    }

    ngOnInit() {
        this.loadFolders();
    }

    ngOnChanges() {
        this.loadFolders();
    }

    loadFolders() {
        if (this.hasFolderId) {
            this.loadFolderFolders();
        } else {
            this.loadRootFolders();
        }
    }

    loadRootFolders() {
        this.folderService.getRootFolders().subscribe(folders => this.folders = folders);
    }

    loadFolderFolders() {
        this.folderService.getFolderFolders(this.folderId).subscribe(data => this.folders = data);
    }

    delete(folder: Folder) {
        this.folders = this.folders.filter(f => f.id !== folder.id);
    }

    create() {
        this.emitter.emit({type: 'folder-create'});
    }

    confirmDelete(folder: Folder) {
        this.emitter.emit({type: 'folder-delete', folder: folder});
    }

    edit(folder: Folder) {
        this.emitter.emit({type: 'folder-edit', folder: folder});
    }

    move(folder: Folder) {
        this.emitter.emit({type: 'folder-move', folder: folder});
    }

    addFolder(folder: Folder) {
        this.folders.push(folder);
    }

}



// WEBPACK FOOTER //
// ./src/app/folder/folder-list/folder-list.component.ts